var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"model":_vm.val},on:{"input":function($event){_vm.val = $event}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('labels.none')))]),_vm._l((_vm.sources),function(s){return _c('option',{key:s.id,domProps:{"value":s.id}},[_vm._v(_vm._s(s.name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }